// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".customMap .mapboxgl-marker{cursor:pointer}.map-overlay--legend{position:absolute;top:0;left:0;background:#fff;margin-top:10px;margin-left:10px;font-family:Arial,sans-serif;overflow:auto;border-radius:3px;padding:10px;box-shadow:0 1px 2px rgba(0,0,0,.1)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
